<template>
  <app-base-main
      :hasMagin="false"
      :no-padding="true"
      parentTable
      :table-border-top="true"
      :table-shadow="false">
    <template #filter-group>
      <app-filter-group
          advancedFiltering
          :screenOptons="screenOptons"
          @determine="filterQuery"
          @clear="filterQuery"
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <ad-campaign-select v-model="campaignIds" :marketId="marketId" :portfolioId="portfolioId" v-if="!inCampaign" adType="SB"></ad-campaign-select>
        <gj-select
            :options="AdProductTargetEnum.SB.statusOption"
            v-model="state"
            placeholder="状态"
        ></gj-select>
        <gj-date-picker
            v-model="date"
            type="daterange"
            :clearable="false"
            tooltip="数据时间"
            :max-day-length="180"
        ></gj-date-picker>
        <gj-search-input
            placeholder="请输入活动名称"
            v-model="keyword"
            width="150px"
        ></gj-search-input>
        <template v-if="!$permission('adsSpCampaigns:addOrUpdate')" #right>
          <gj-tool-group
              :helpName="helpName"
              log @viewLog="viewLog"
              help
              setting :table-name="tableName" :table-columns="columns"
              :download="$permission('adsSbCampaigns:export')" download-url="/ads/adsSbProductTargeting/export" :download-params="globalParams"
          ></gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #operate-group>
      <gj-button
          type="primary"
          :disabled="adStore.SB && adStore.SB.campaign && adStore.SB.campaign.updateFlag === 0"
          @click="add"
      >新增商品投放</gj-button>
      <gj-button @click="adjustBidAddPopup" :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIsNot('state', AdProductTargetEnum.SB.status.ARCHIVE)"> 应用建议竞价 </gj-button>
      <gj-button
          :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIsNot('state', AdProductTargetEnum.SB.status.ARCHIVE)"
          @click="adjustBid">
        调整竞价
      </gj-button>
      <gj-button
          :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIs('state', AdProductTargetEnum.SB.status.PAUSE)"
          @click="enable(selectedRows)">
        启用
      </gj-button>
      <gj-button
          :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIs('state', AdProductTargetEnum.SB.status.ENABLE)"
          @click="pause(selectedRows)">
        暂停
      </gj-button>
      <gj-button
          v-if="$permission('adsSpCampaigns:delete')"
          :disabled="selectedSomeIsNot('updateFlag', 1) || !selectedAllIn('state', [AdProductTargetEnum.SB.status.ENABLE, AdProductTargetEnum.SB.status.PAUSE])"
          @click="archive">
        归档
      </gj-button>
    </template>
    <template v-if="$permission('adsSpCampaigns:addOrUpdate')" #tool-group>
      <gj-tool-group
          :helpName="helpName"
          log @viewLog="viewLog"
          help
          setting :table-name="tableName" :table-columns="columns" :sort-gjtable="$refs.gjTable"
          :download="$permission('adsSbCampaigns:export')" :download-params="globalParams" download-url="/ads/adsSbProductTargeting/export"
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :name="tableName"
          :selection="$permission('adsSpCampaigns:addOrUpdate')"
          size="has-picture"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          sortable="custom"
          :pagination="pagination"
          :summary-object="sumRecord"
          show-summary
          :selectable="notEqSelectable('state', AdProductTargetEnum.SB.status.ARCHIVE)"
          :default-sort="defaultSort"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:status="{ row }">
          <template v-if="$permission('adsSpCampaigns:addOrUpdate')">
            <gj-tag
                v-if="row.state === AdProductTargetEnum.SB.status.ARCHIVE"
                color="#AFBACB">已归档</gj-tag>
            <gj-switch
                v-else
                size="small"
                :value="row.state === AdProductTargetEnum.SB.status.ENABLE"
                :disabled="row.updateFlag === 0"
                @input="switchStatus($event, row)"
            ></gj-switch>
          </template>
          <template v-else>
            {{row.state | optionText(AdProductTargetEnum.SB.statusOption) | defaultShow}}
          </template>
        </template>
        <template v-slot:state="{ row }">
          <div :class="[row.state === 1 ? 'ccc' : '']">{{ row.state | optionText(AdProductTargetEnum.SB.stateOption) | defaultShow}}</div>
        </template>
        <template v-slot:belongCampaign="{row}">
          <app-sp-ad-route-link
              :ad-campaign-manager="{marketId, campaign: row}">
            <gj-tooltip
                :text-line="2"
                :content="row.campaignName">
              {{row.campaignName | defaultShow}}
            </gj-tooltip>
          </app-sp-ad-route-link>
        </template>
        <template v-slot:bid="{row}">
          {{row.bid | defaultShow(row.currencySymbol)}}
        </template>
        <!-- 建议竞价 -->
        <template v-slot:suggestBid="{ row }">
          <div v-if="!row.resolvedExpressionList || row.resolvedExpressionList.length == 0 || !row.resolvedExpressionList[0] || row.resolvedExpressionList[0].type != 'asinSameAs'">-</div>
          <div v-else class="bid-refresh" style="color: #0046f0;">
              <i class="el-icon-refresh" v-if="!row.refresh" @click="bidRefresh()" style="cursor: pointer;"></i>
              <i class="el-icon-loading" v-else-if="row.refresh == 1"></i>
              <div v-else-if="row.refresh == 2">
                <div>{{ row.recommended  | defaultShow(row.currencySymbol)}}</div>
                <div style="color: #333">
                  {{ row.rangeStart | defaultShow(row.currencySymbol)}} ~ 
                  {{ row.rangeEnd | defaultShow(row.currencySymbol)}}
                </div>
              </div>
              <div style="color: #999;" v-else-if="row.refresh == 3">暂无建议</div>
          </div>
        </template>
        <template v-slot:productTargetName="{row}">
          <template v-if="row.resolvedExpressionList && row.resolvedExpressionList.length > 0">
            <gj-tooltip
                v-for="(item, i) in row.resolvedExpressionList"
                :key="i"
                :content="`${item.type}=${item.value}`"
                :text-line="1">
              <template v-if="item.type === 'asinSameAs'">
                asinSameAs=<gj-link :href="row.asinAmazonUrl" target="_blank">{{item.value}}</gj-link>
              </template>
              <template v-else-if="item.type === 'exactProduct'">商品浏览</template>
              <template v-else-if="item.type === 'similarProduct'">类似商品浏览</template>
              <template v-else-if="isMeaningful(item.type) && isMeaningful(item.value)">
                {{item.type}}={{item.value}}
              </template>
              <template v-else>-</template>
            </gj-tooltip>
          </template>
          <template v-else>-</template>
        </template>
        <template v-slot:op="{row}">
          <gj-button type="text"  @click="viewLog(row)"> 操作日志 </gj-button>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {adFields} from "modules/ad/common/fields";
  import {
    adBaseDataMixin, adDefaultSortMixin,
    adAdvancedFilteringMixin,
    currencySymbolMixin,
    inCampaignMixin,
    inMarketMixin,
    inPortfolioMixin,
    tableNameMixin,
    inGroupMixin, resizeMixin, initDateMixin
  } from "modules/ad/common/mixin";
  import {isMeaningfulMixin, queryMixin, responseMixin, selectionMixin} from "@/minxins";
  import AppAdjustBidModal from "modules/ad/common/modal/adjust/adjust-bid-modal";
  import AppArchiveWarningModal from "modules/ad/common/modal/update-status/archive-warning-modal";
  import {AdProductTargetEnum, AdStrategyStatusEnum} from "modules/ad/common/enum";
  import AppAddSpAdProductTarget from "../../common/modal/add/product-target/add-ad-product-target";
  import {subDays} from 'date-fns';
  import {defaultVal, isMeaningful, isMeaningless, transformToMap} from "@/utils/common";
  import {convertToDate} from "@/utils/date.util";
  import {adStore} from "modules/ad/common/store";
  import AppSpAdRouteLink from "../../common/components/ad-route-link";
  import AdCampaignSelect from "modules/ad/common/components/ad-campaign-select.vue"
  import AppAdLogModal from "modules/ad/common/modal/log/ad-log-modal";
  import {LOG_OP_TYPE} from "modules/ad/common/options";
  import {addAdsAdjustStrategy, updateAdsAdjustStrategyObject, adsSbProductTargetingPage, adsSbProductTargetingUpdate, adsSbBasicDataBids} from "@/api/ad";
  import AddPopup from "modules/ad/sb/ad-add/components/other/popup.vue";
  import { getAsinInfo } from '@/views/modules/ad/config'

  export default {
    name: "app-sp-ad-product-target",
    components: {AppSpAdRouteLink, AdCampaignSelect},
    mixins: [
      inMarketMixin, inPortfolioMixin, inGroupMixin, resizeMixin,
      inCampaignMixin, tableNameMixin, selectionMixin,
      adBaseDataMixin, queryMixin, currencySymbolMixin,
      isMeaningfulMixin, adDefaultSortMixin, responseMixin, initDateMixin,
      adAdvancedFilteringMixin
    ],
    inject: ['getBrandAdvertisingCornerMark'],
    created() {
      this.columns = [
        adFields.status,
        {...adFields.picture, field: 'picture:asinImageUrl'},
        {...adFields.productTargetName, minWidth: '200px'},
        {id: 'state', header: '状态', field: 'slot:state', minWidth: '100px', default: true},
        this.inCampaign ? null : adFields.belongCampaign,
        // this.inCampaign ? null : adFields.belongPortfolio,
        // adFields.creationDate,
        adFields.suggestBid,
        {...adFields.bid, minWidth: '80px'},
        adFields.impressions,
        adFields.clicks,
        adFields.ctr,
        adFields.cost,
        adFields.cpc,
        adFields.orders,
        adFields.cvr,
        adFields.cpa,
        adFields.sales,
        adFields.acos,
        adFields.roas,
        {...adFields.op, width: '80px'},
      ].filter(e => e!== null);
    },
    data() {
      return {
        helpName:'sbadmanager',
        adStore,
        campaignIds: [],
        tableData: [],
        columns: [],
        AdProductTargetEnum: AdProductTargetEnum,
        AdStrategyStatusEnum: AdStrategyStatusEnum,
        extendSearch: null,
        state: AdProductTargetEnum.SB.statusOption[0].id,
        date: [subDays(new Date(), 6), new Date()],
        keyword: null,
        sumRecord: {}
      }
    },
    methods: {
      // 竞价刷新
      async bidRefresh() {
        this.tableData.forEach(e => {
          this.$set(e, "refresh", 1)
        });
        let targets = this.tableData
          .filter(e => e.resolvedExpressionList[0] && e.resolvedExpressionList[0].type == 'asinSameAs')
          .map(e => ([
            ...e.resolvedExpressionList
          ]))
        let params = {
          targets,
          marketId: this.marketId
        }
        // console.log('zs', params);
        try {
          let { data } = await adsSbBasicDataBids(params)
          this.tableData.forEach(e => {
            let item = data.targetsBidsRecoSuccessResults.find(j => {
              let item2 = j.targets.find(j2 => j2.value.toUpperCase() == e.resolvedExpressionList[0].value.toUpperCase())
              if (item2) return j
            })
            if (item) {
              if (item.recommendedBid) {
                this.$set(e, "refresh", 2)
                this.$set(e, "rangeEnd", item.recommendedBid.rangeEnd)
                this.$set(e, "rangeStart", item.recommendedBid.rangeStart)
                this.$set(e, "recommended", item.recommendedBid.recommended)
              }else {
                this.$set(e, "refresh", 3)
              }
            }
          })
        } catch (error) {
          console.log(error);
        }
      },
      marketChange(marketId) {
        if (isMeaningful(marketId)) {
          this.$gjNoticeQuery();
        }
      },
      portfolioChange(portfolioId) {
        this.$gjNoticeQuery();
      },
      campaignChange(campaignId) {
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          campaignIds: [],
          state: AdProductTargetEnum.SB.statusOption[0].id,
          date: this.initDate || [subDays(new Date(), 6), new Date()],
          extendSearch: null,
          keyword: null
        };
      },
      $gjQuery() {
        if (isMeaningless(this.marketId)) {
          return;
        }
        this.getBrandAdvertisingCornerMark()
        // 构造查询参数
        const params = {
          model: {
            campaignIds: this.campaignIds,
            marketId: this.marketId,
            portfolioId: this.portfolioId,
            campaignId: this.campaignId,
            state: this.state,
            campaignName: this.keyword,
            extendSearch: this.extendSearch,
            startDate: convertToDate(this.date[0]),
            endDate: convertToDate(this.date[1]),
          },
          ...this.queryPagination,
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        adsSbProductTargetingPage(params)
          .then(async ({data}) => {
            if (isMeaningful(data)) {
              const tableData = this.currencySymbolMixin(data.records, adStore.SB.currencySymbol) || [];
              tableData.forEach(e => {
                try {
                  e.resolvedExpressionList = JSON.parse(e.expressions);
                } catch (e) {
                  e.resolvedExpressionList = [];
                }
              });
              this.tableData = tableData;
              this.tableData = this.tableData.map(e => ({
                ...e,
                refresh: null,
                rangeEnd: null,
                rangeStart: null,
                recommended: null,
              }))
              getAsinInfo('expressionsValue', this.tableData[0].marketId, data.countryCode, this.tableData, 'asinImageUrl');
              this.sumRecord = data.sumRecord;
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          })
      },
      // 设置建议竞价弹窗
      adjustBidAddPopup() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            content: `请确认将选择的<span style="color: red;font-weight: bold;">${this.selectedRows.length}</span>个商品投放竞价调整到建议竞价，更改时只对有建议竞价的对象进行操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              this.adjustBidQuick()
              modal.$gjDestroy()
            }
          }
        });
      },
      // 设置建议竞价
      adjustBidQuick() {
        for (const e of this.selectedRows) {
          if (!e.recommended) {
            this.$gjMessage.error('请先获取建议竞价')
            this.bidRefresh()
            return false
          }
        }
        this.loading = true
        let params = {
            marketId: this.marketId,
            targetsBeans: this.selectedRows.map(e => ({
            campaignId: e.campaignId,
            groupId: e.groupId,
            targetId: e.targetId,
            adjustmentType: "0",
            adjustmentValue: e.recommended,
          })),
        }
        adsSbProductTargetingUpdate(params)
          .then(() => {
            this.$gjMessage.success('操作成功');
            this.$gjResetPage();
            modal.$gjDestroy()
          })
          .complete(() => this.loading = false);
      },
      adjustBid() {
        const modal = this.$gjCreate(AppAdjustBidModal, {
          props: {
            currencySymbol: adStore.SB.currencySymbol,
            alertRules: [
              '选择将竞价调整：直接输入目标竞价',
              '按百分比提高/降低竞价公式：目标竞价 = 原始竞价 * ( 100 ± 输入值) / 100',
              '按固定金额提高/减低竞价公式：目标竞价 = 原始竞价 ± 输入值',
              '竞价调整四舍五入精确到小数点后两位数',
            ]
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                 marketId: this.marketId,
                 targetsBeans: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  groupId: e.groupId,
                  targetId: e.targetId,
                  adjustmentType: modal.form.bid.key,
                  adjustmentValue: modal.form.bid.value,
                })),
              }
              adsSbProductTargetingUpdate(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy()
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      add() {
        this.$gjCreate(AppAddSpAdProductTarget, {
          props: {
            marketId: this.marketId,
            campaign: this.campaign,
            group: this.group
          },
          on: {
            created: () => {
              this.$gjMessage.success('创建成功');
              this.$gjResetPage();
            }
          }
        });
      },
      switchStatus(open, row) {
        if (open) {
          this.enable([row]);
        } else {
          this.pause([row]);
        }
      },
      enable(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "启用确认",
            content: `已选择 ${rows.length} 个商品投放，确认启用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              let params = {
                 marketId: this.marketId,
                 targetsBeans: rows.map(e => ({
                  campaignId: e.campaignId,
                  groupId: e.groupId,
                  targetId: e.targetId,
                  state: AdProductTargetEnum.SB.status.ENABLE
                })),
              }
              adsSbProductTargetingUpdate(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      pause(rows) {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "停用确认",
            content: `已选择 ${rows.length} 个商品投放，确认停用？`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              let params = {
                 marketId: this.marketId,
                 targetsBeans: rows.map(e => ({
                  campaignId: e.campaignId,
                  groupId: e.groupId,
                  targetId: e.targetId,
                  state: AdProductTargetEnum.SB.status.PAUSE
                })),
              }
              adsSbProductTargetingUpdate(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      archive() {
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: "归档确认",
            content: `归档后亚马逊会
            <span style="color: red;font-weight: bold;">删除</span>这些活动，
            不能再开启，
            <span style="color: red;font-weight: bold;">此操作不可逆</span>，
            请谨慎操作！`
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              let params = {
                 marketId: this.marketId,
                 targetsBeans: this.selectedRows.map(e => ({
                  campaignId: e.campaignId,
                  groupId: e.groupId,
                  targetId: e.targetId,
                  state: AdProductTargetEnum.SB.status.ARCHIVE
                })),
              }
              adsSbProductTargetingUpdate(params)
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
      viewLog(row) {
        this.$gjCreate(AppAdLogModal, {
          props: {
            marketId: this.marketId,
            campaignId: this.campaignId,
            name: '',
            opId: isMeaningful(row) ? row.targetId : null,
            adType: LOG_OP_TYPE.SB,
            operatingObjectTypeProps: 8,
            object: LOG_OP_TYPE.SB.PRODUCT_TARGET
          }
        });
      },
      viewAdjustLog(row) {

      }
    }
  }
</script>

<style scoped>
  .ccc {
    color: #969696 !important;
  }
</style>
